import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import react from 'react';
import axios from 'axios';
import {host} from '../../function/api'

const initialState = {
    loading: false,
    success: false,
    message: '',
    FactorMessage: '',
    customerMessage: '',
    customerLoading: '',
    customerSuccess: '',
    customerStatus: '',
    customers: [],
    customer: [],
    customerVerificationCode: '',
    errorCustomer: '',
    errorType: '',
    errorNumber: '',
    errorCustomerType: '',
    errorCustomerNumber: '',
    errorVerificationMobile: '',
    errorVerificationCode: '',
    verificationMessage: '',
    customerDocumentList: '',
    Factorremaining: '',
    Factorcount_row: '',
    Factortotal: ''
}

export const factorImport = createAsyncThunk(
    'factorImport',
    async(data, thunkAPI) => {
        try {
            const response = await axios({
                method: 'POST',
                url: `${host}factor/import`,
                data: data,
                headers: {
                    'Accept': 'application/json',
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    // 'withCredentials': true,
                    "Content-Type": "multipart/form-data",
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })

            return await response.data;

        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
)
export const customerStore = createAsyncThunk(
    'customerStore',
    async(data, thunkAPI) => {
        try {
            const response = await axios({
                method: 'POST',
                url: `${host}customer`,
                data: data,
                headers: {
                    'Accept': 'Application/json',
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })

            return await response.data;

        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
)

export const factorIndex = createAsyncThunk(
    'factorIndex',
    async(thunkAPI) => {
        try {
            const response = await axios({
                method: 'GET',
                url: `${host}factors`,
                headers:{
                    'Accept': 'Application/json',
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })

            return await response.data;

        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
)

export const documentList = createAsyncThunk(
    'documentList',
    async(data, thunkAPI) => {
        try {
            const response = await axios({
                method: 'post',
                url: `${host}customer/documents`,
                data:data,
                headers:{
                    'Accept': 'Application/json',
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })

            return await response.data;

        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
)

export const searchCustomer = createAsyncThunk(
    'searchCustomer',
    async(data, thunkAPI) => {
        try {
            const response = await axios({
                method: 'POST',
                url: `${host}customer/search`,
                data:data,
                headers:{
                    'Accept': 'Application/json',
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })

            return await response.data;

        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
)

export const findCustomer = createAsyncThunk(
    'findCustomer',
    async(data, thunkAPI) => {
        try {
            const response = await axios({
                method: 'POST',
                url: `${host}customer/find`,
                data: data,
                headers:{
                    'Accept': 'Application/json',
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })

            return await response.data;

        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
)

export const mobileVerificationCode = createAsyncThunk(
    'mobileVerificationCode',
    async(data , thunkAPI) => {
        try{
            const response = await axios({
                method: 'POST',
                url: `${host}customer/mobile/verificationCode`,
                data: data,
                headers: {
                    'Accept': 'application/json',
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })

            return response.data;

        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
)

const factorSlice = createSlice({
    name: 'factor',
    initialState,
    reducers: {

    },
    extraReducers: {
        [factorImport.fulfilled]: (state, action) => {
            state.loading = false;
            state.success = true;
            state.status = true;
            state.Factorcount_row = action.payload.count_row;
            state.Factorremaining = action.payload.remaining;
            state.Factortotal = action.payload.total;
            state.FactorMessage = action.payload.message;
        },
        [factorImport.pending]: (state) => {
            state.loading= true;
            state.success = false;
            state.status = false;
            state.Factorcount_row = '';
            state.Factortotal = '';
            state.FactorMessage = '';
        },
        [factorImport.rejected]: (state, { payload }) => {
            state.loading = false;
            state.success = false;
            state.status = false;
            state.Factorcount_row = payload.response.data.count_row;
            state.Factortotal = payload.response.data.total;
            state.Factorremaining = payload.response.data.remaining;
            state.FactorMessage = payload.response.data.message
           
            if(payload.response.data.error) {
                state.error = payload.response.data.error
            }
        },
        [customerStore.fulfilled]: (state,{ payload }) => {
            state.loading = false;
            state.success = true;
            state.message = payload.message;
        },
        [customerStore.pending]: (state) => {
            state.loading= true;
        },
        [customerStore.rejected]: (state, { payload }) => {
            state.loading = false;
            if(payload.response.data.error) {
                state.errorCustomer = payload.response.data.error.customer
            }
        },
        [factorIndex.fulfilled]: (state, action) => {
            state.loading = false;
            state.success = true;
            state.status = true;
            state.customers = action.payload.data
        },
        [factorIndex.pending]: (state) => {
            state.loading = true;
            state.success = false;
            state.status = false;
        },
        [factorIndex.rejected]: (state, { payload }) => {
            state.loading = false;
            state.success = false;
            state.status = false;
            console.log(payload)
            if(payload.response.data.error){
                state.error = payload.response.data.error
            } else if (payload.response.data.message) {
                state.message = payload.response.data.message
            }
        },
        [findCustomer.fulfilled]: (state, action) => {
            state.customerLoading = false;
            state.customerSuccess = true;
            state.customerStatus = true;
            state.customer = action.payload.data
            state.customerMessage = action.payload.message
        },
        [findCustomer.pending]: (state) => {
            state.customerLoading = true;
            state.customerSuccess = false;
            state.customerStatus = false;
            state.customer = []
            state.customerMessage = ''
            state.errorCustomerType = ''
            state.errorCustomerNumber = ''
        },
        [findCustomer.rejected]: (state, { payload }) => {
            state.customerLoading = false;
            state.customerSuccess = false;
            state.customerStatus = false;
            state.customer = []
            if(payload.response.data.error){
                state.errorCustomerType = payload.response.data.error.type
                state.errorCustomerNumber = payload.response.data.error.number
            }
            if (payload.response.data.message) {
                state.customerMessage = payload.response.data.message
            }
        },
        [mobileVerificationCode.fulfilled]: (state, action) => {
            state.loading = false
            state.success = true
            state.status = true
            state.customerVerificationCode = action.payload.data
            state.verificationMessage = action.payload.message
        },
        [mobileVerificationCode.pending] : (state) => {
            state.loading = true
            state.success = false
            state.status = false
            state.customerVerificationCode = ''
        },
        [mobileVerificationCode.rejected]: (state, {payload}) => {
            state.loading = false
            state.success = false
            state.status = false
            if(payload.response.data.error) {
                state.errorVerificationMobile = payload.response.data.error.mobile
                state.errorVerificationCode = payload.response.data.error.code
            }else if(payload.response.data.message) {
                state.verificationMessage = payload.response.data.message
            }

        },
        [documentList.fulfilled]: (state, action) => {
            state.loading = false;
            state.success = true;
            state.status = true;
            state.customerDocumentList = action.payload.data
        },
        [documentList.pending]: (state) => {
            state.loading = true;
            state.success = false;
            state.status = false;
            state.customerDocumentList = ''
        },
        [documentList.rejected]: (state, { payload }) => {
            state.loading = false;
            state.success = false;
            state.status = false;
            if(payload.response.data.error){
                state.error = payload.response.data.error
            } else if (payload.response.data.message) {
                state.message = payload.response.data.message
            }
        },
        [searchCustomer.fulfilled]: (state, action) => {
            state.loading = false;
            state.success = true;
            state.status = true;
            state.customers = action.payload.data
        },
        [searchCustomer.pending]: (state) => {
            state.loading = true;
            state.success = false;
            state.status = false;
        },
        [searchCustomer.rejected]: (state, { payload }) => {
            state.loading = false;
            state.success = false;
            state.status = false;
            if(payload.response.data.error){
                state.error = payload.response.data.error
            } else if (payload.response.data.message) {
                state.message = payload.response.data.message
            }
        }
    }
})

export const {} = factorSlice.actions;
export default factorSlice.reducer;